import { render, staticRenderFns } from "./AccessoriesOrdering.vue?vue&type=template&id=0425316e&scoped=true&"
import script from "./AccessoriesOrdering.vue?vue&type=script&lang=js&"
export * from "./AccessoriesOrdering.vue?vue&type=script&lang=js&"
import style0 from "./AccessoriesOrdering.vue?vue&type=style&index=0&id=0425316e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0425316e",
  null
  
)

export default component.exports